import type { ComponentProps } from 'react';
import { Text as RNText, View } from 'react-native';

import { cn } from '@/lib/design-system/cn';
import type { BadgeVariant } from '@/lib/design-system/variants';
import { badgeVariantClass } from '@/lib/design-system/variants';

export type BadgeProps = ComponentProps<typeof View> & {
  label: string;
  variant?: BadgeVariant;
};

export function Badge({ label, variant = 'neutral', className, ...props }: BadgeProps) {
  return (
    <View className={cn('cs-badge', badgeVariantClass[variant], className)} {...props}>
      <RNText className="text-caption font-medium">{label}</RNText>
    </View>
  );
}
